module.exports = __webpack_public_path__ + "img/logo-asaas.2ab79403.svg";